/**
 * Copyright (c) 2010-2021 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { FetchProxy } from './fetch.proxy';
import { from, Observable } from 'rxjs';
import { FetchProxyResponse } from './fetch-proxy-response';
import * as Comlink from 'comlink';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { FetchWorker } from './fetch-worker.class';
import { LoggerService } from '../services/logger.service';

declare type ResponseType = 'json' | 'text' | 'blob' | 'arraybuffer';

@Injectable({ providedIn: 'root' })
export class FetchWebWorkerProxy implements FetchProxy {
    private readonly remote: Comlink.Remote<typeof FetchWorker>;

    constructor(private logger: LoggerService) {
        const worker = new Worker(new URL('./fetch.worker', import.meta.url), { type: 'module' });
        this.remote = Comlink.wrap<typeof FetchWorker>(worker);
    }

    send(input: RequestInfo, init?: RequestInit, responseType: ResponseType = 'json'): Observable<FetchProxyResponse> {
        const options = {
            responseType,
        };

        const remotePromise = this.createRequest(input, init, options);
        return from(remotePromise).pipe(catchError((err, caught) => {
            return caught;
        }));
    }

    private async createRequest(input, init, options): Promise<FetchProxyResponse> {
        const instance = await new this.remote();
        try {
            return await instance.sendRequest(input, init, options);
        } catch (e) {
            this.logger.error(e);
        }
    }
}
